{
  "instances": {
    "liquibase": {
      "label": "Liquibase",
      "author": "作者",
      "changelog": "變更日誌",
      "checksum": "檢查碼",
      "comments": "備註",
      "contexts": "執行環境",
      "deployment_id": "部署 ID",
      "description": "說明",
      "execution": "執行",
      "execution_date": "執行日期",
      "execution_order": "執行順序",

      "id": "ID",
      "labels": "標籤",
      "tag": "標記"
    }
  }
}
